import React from 'react';
import { Heading } from '@components/common';
import { MobileContainer } from '@containers/layout';
import MoveoutPropertyForm from './MoveoutPropertyForm';
function MoveoutProperty(props) {
  return (
    <MobileContainer>
      <Heading mb={4}>Enter your new address</Heading>
      <MoveoutPropertyForm {...props} />
    </MobileContainer>
  );
}

export default MoveoutProperty;
